import axios from '../utils/axios';

export const getProfile = () => {
  return axios.get('users/userProfile').then(response => response.data);
}

export const getUserLog = () => {
  return axios.get('users/userLog').then(response => response.data);
}

export const addUser = (user) => {
  return axios.post('services/addUser', user).then(response => response.data);
}
export const addLocation = (location) => {
  return axios.post('services/addLocation', location).then(response => response.data);
}
export const getSrids = () => {
  return axios.get('uploads/srids').then(response => response.data);
}
export const getUsers = () => {
  return axios.get('uploads/pilots').then(response => response.data);
}
export const getLocations = () => {
  return axios.get('uploads/locations').then(response => response.data);
}
export const addUserLocation = (userLocation) => {
  return axios.post('services/addUserLocation',userLocation).then(response => response.data);
}